import { render, staticRenderFns } from "./RegisterPort.vue?vue&type=template&id=71e9b185&"
import script from "./RegisterPort.vue?vue&type=script&lang=ts&"
export * from "./RegisterPort.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterPort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports